export type MultiSelectType = 'checkbox' | 'color';

export interface Item {
  id: string;
  value: string;
  label: string | JSX.Element;
  isRefined: boolean;
  count: number;
}

export type MergeFiltersByAlias = Record<string, Item>;

export enum Colors {
  Brown = 'brown',
  Red = 'red',
  Purple = 'purple',
  Pink = 'pink',
  Yellow = 'yellow',
  Green = 'green',
  Orange = 'orange',
  Blue = 'blue',
  Beige = 'beige',
  Grey = 'grey',
  Black = 'black',
  White = 'white',
}

export enum SpecificColors {
  Multicolor = 'multicolor',
  Transparent = 'transparent',
  Silver = 'silver',
  Golden = 'golden',
  Copper = 'copper',
  Other = 'other',
}

export type ColorGroup = Colors | SpecificColors;
